
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M496.128 220.361l-160-144.032c-19.712-17.728-50.08-16.192-67.808 3.584-17.728 19.68-16.128 50.048 3.584 67.776l66.976 60.32H48c-26.528 0-48 21.472-48 48s21.472 48 48 48h290.944l-67.072 60.32c-19.712 17.76-21.312 48.096-3.584 67.776A48.006 48.006 0 00304 448.009c11.456 0 22.944-4.064 32.096-12.32l160-143.968A48.014 48.014 0 00512 256.041a48.1 48.1 0 00-15.872-35.68z"}})])
          )
        }
      }
    